export const FLOW_STEP_DATE = 'startDate'
export const FLOW_STEP_PRODUCT = 'product'
export const FLOW_STEP_DELIVERY = 'delivery'
export const FLOW_STEP_REVIEW = 'reviewPay'
export const FLOW_STEP_SUCCESS = 'success'
export const FLOW_STEP_VEHICLE = 'vehicles'
export const FLOW_STEP_EVENT = 'event'
export const FLOW_STEP_PIX = 'pix'
export const FLOW_STEP_ACCESS_OPTIONS = 'accessOptions'

export const PURCHASE_FLOW = [
    FLOW_STEP_DATE,
    FLOW_STEP_PRODUCT,
    FLOW_STEP_VEHICLE,
    FLOW_STEP_ACCESS_OPTIONS,
    FLOW_STEP_REVIEW,
].filter(step => step)

export const CREDENTIAL_LPR = 'LPR'
export const CREDENTIAL_PHYSICAL = 'Physical'
export const CREDENTIAL_DIGITAL = 'Digital'

export const DELIVERY_COLLECT = 'collect'
export const DELIVERY_HOME = 'send_to_address'
export const DELIVERY_STANDART = 'standard'
export const DELIVERY_EXPRESS = 'express'
export const DELIVERY_COLLECT_RATE_ID = 'collect'
export const DELIVERY_STANDART_CODE = 'STND'
export const DELIVERY_EXPRESS_CODE = 'EXPR'
export const DELIVERY_COLLECT_CODE = 'collect'

export const PURCHASE_FLOW_HEADER_PREFIX = 'subscription'

export const DIGITAL_PASS_ACCESS_ID = 'TICKETLESS'
export const DIGITAL_PASS_PRICE = '0.00'
export const DIGITAL_PASS_NAME = 'Digital pass'
export const CANADA_CURRENCY = '$'
export const RATE_TYPE_MONTHLY_PASS = 'MonthlyPass'
